export default "/assets/site/images/kopacsi_edina.png?a7677d5547158267b66c90232c386e2e";